import React from "react"
import PropTypes from "prop-types"
import styled, { css } from "styled-components"
import NavbarMenuPopupRight from "./navbar-menu-popup-right"
import NavbarMenuPopup from "./navbar-menu-popup"

const Item = styled.div`
  color: #1f1f23;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0.25px;
  cursor: pointer;
  &:hover {
    color: #3a6968;
  }
  ${props =>
    props.$showPopup &&
    css`
      color: #3a6968;
    `}
`

const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const PopupHolder = styled.div`
  max-width: 0;
  max-height: 0;
  position: relative;
  display: ${props => (props.$show ? "block" : "none")};
`
const NavbarItem = ({
  name,
  items,
  index,
  showPopup,
  setShowpopup,
  header,
}) => {
  return (
    <ItemWrapper onMouseEnter={() => setShowpopup(index)}>
      <Item $showPopup={showPopup === index}>{name}</Item>

      <PopupHolder $show={showPopup === index}>
        {index < 3 && (
          <NavbarMenuPopup
            setShowpopup={setShowpopup}
            items={items}
            showPopup={showPopup}
            index={index}
            header={header}
          />
        )}
        {index >= 3 && (
          <NavbarMenuPopupRight
            setShowpopup={setShowpopup}
            items={items}
            showPopup={showPopup}
            index={index}
            header={header}
          />
        )}
      </PopupHolder>
    </ItemWrapper>
  )
}

NavbarItem.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  setShowpopup: PropTypes.func,
  showPopup: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  header: PropTypes.object,
  index: PropTypes.number,
  name: PropTypes.string,
}

export default NavbarItem
